module.exports = "https://static.wmbcdn.com/uniweb/images/2b0c9ec798ef3a3135ecfd094d33943e.svg";